// frontend/src/services/api.js
import axios from 'axios';

// Variable de entorno para la URL de la API
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "ngrok-skip-browser-warning": "true"
  }
});

// --- Request Interceptor: Añadir token ---
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- Response Interceptor: Manejar errores 401/403 ---
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';

    // No interceptar errores en login (el usuario quiere ver "credenciales inválidas")
    const isLoginRequest = requestUrl.includes('/auth/login');

    if (status === 401 && !isLoginRequest) {
      // Token expirado o inválido → limpiar sesión y redirigir
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      window.dispatchEvent(new Event('storage'));
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;